"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/style"));
var _items = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items"));
var _utils = require("webmotors-react-pj/utils");
var _hamburg = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/hamburg"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    setOpened
  } = _ref;
  if (!window.clickHeader) {
    window.clickHeader = true;
    window.addEventListener('click', e => {
      const {
        target
      } = e;
      const headerPopoverAttribute = 'data-header-popover';
      const popoverAttribute = 'data-popover-open';
      const header = document.querySelector('[data-header]');
      const iconClicked = target.hasAttribute('data-icon-click');
      const iconNextElement = target.nextElementSibling;
      const removePopover = () => document.querySelectorAll("[".concat(popoverAttribute, "]")).forEach(item => item.removeAttribute(popoverAttribute));
      if (!target.closest('.modal')) {
        if (iconClicked && iconNextElement && !iconNextElement.hasAttribute(popoverAttribute) || target.closest("[".concat(popoverAttribute, "]"))) {
          if (!target.closest("[".concat(popoverAttribute, "]"))) {
            removePopover();
          }
          header.setAttribute(headerPopoverAttribute, '');
          iconNextElement && iconNextElement.setAttribute(popoverAttribute, '');
        } else {
          removePopover();
          header.removeAttribute(headerPopoverAttribute);
        }
      }
    });
  }
  (0, _react.useEffect)(() => {
    const jwt = (0, _utils.jwtGet)();
    const token = (0, _utils.cookieGet)('CockpitLogged');
    window.prechat_inputs = {
      nome: jwt.nameid,
      email: jwt.email,
      cnpj: jwt.cnpj,
      perfilusuario_cockpit: jwt.role,
      'erase-authorization-cockpit': token
    };
  }, []);
  return _react.default.createElement(_style.default, {
    "data-header": true
  }, _react.default.createElement(_hamburg.default, {
    onClickEvent: setOpened
  }), _react.default.createElement(_items.default, null));
};
exports.default = _default;